import { DATE_FORMAT_LONG_FNS, DATE_FORMAT_LONG_MINUTE_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { IKnmPmFormRescheduling } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormRescheduling';

import { IKnmErknmFormEvent } from '../interfaces/IKnmErknmFormEvent';
import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import { getActEventValidator } from './getActEventValidator';
import { getErknmEventValidate } from './getErknmEventValidate';
import { IKnmErknmFormRescheduling } from '../interfaces/IKnmErknmFormRescheduling';
import { IKnmErknmFormInspector } from '../interfaces/IKnmErknmFormInspector';
import { IKnmErknmFormSuspensionEvent } from '../interfaces/IKnmErknmFormSuspensionEvent';

interface IGetErknmActEventsValidateProps {
  events: IKnmErknmFormEvent[] | undefined;
  holdingDateTime: string | undefined;
  isInteractionCategoryOrInspectorRequired: boolean | undefined;
  isPaperless: boolean | undefined;
  rescheduling: (IKnmErknmFormRescheduling[] & IKnmPmFormRescheduling[]) | null | undefined;
  inspectorsErknm: IKnmErknmFormInspector[] | undefined;
  isKnmStatusTypeCompleted: boolean | undefined;
  stopDate: string | undefined;
  startDate: string | undefined;
  isValidateActionStartDateInKnmAct: boolean;
  isShow22: boolean;
  isProsecutorOrSuperProsecutor: boolean | undefined;
  isKnmStatusApproving: boolean | undefined;
  isPm?: boolean | undefined;
  eventsMain?: IKnmErknmFormEvent[] | undefined;
  suspensionEvents?: IKnmErknmFormSuspensionEvent[];
}

export const getErknmActEventsValidate = ({
  events,
  holdingDateTime,
  isPaperless,
  isInteractionCategoryOrInspectorRequired,
  inspectorsErknm,
  isKnmStatusApproving,
  isKnmStatusTypeCompleted,
  isProsecutorOrSuperProsecutor,
  isShow22,
  isValidateActionStartDateInKnmAct,
  rescheduling,
  startDate,
  stopDate,
  isPm,
  eventsMain,
  suspensionEvents,
}: IGetErknmActEventsValidateProps): FormErrors<IKnmErknmFormEvent>[] | string | undefined => {
  if (!isPaperless) {
    if (!isInteractionCategoryOrInspectorRequired || !events || !events?.length) {
      return undefined;
    }

    if (!events || events.length === 0) {
      return 'Поле не может быть пустым';
    }
  }

  const holdingDate = formatDate({
    date: holdingDateTime || '',
    dateFormat: DATE_FORMAT_LONG_FNS,
    parseFormat: DATE_FORMAT_LONG_MINUTE_FNS,
  });

  return events?.map(item => {
    const suspensionEventsForActEvent = suspensionEvents?.filter(
      suspensionEv => suspensionEv.event?.type?.label === item.type?.label,
    );

    return isPaperless
      ? getActEventValidator(
          item,
          holdingDate,
          inspectorsErknm,
          isInteractionCategoryOrInspectorRequired,
          isKnmStatusTypeCompleted,
          isPm,
          eventsMain,
          suspensionEventsForActEvent,
        )
      : getErknmEventValidate({
          item,
          isActEvent: true,
          holdingDate,
          inspectorsErknm,
          isInteractionCategoryOrInspectorRequired,
          isKnmStatusApproving,
          isKnmStatusTypeCompleted,
          isProsecutorOrSuperProsecutor,
          isShow22,
          isValidateActionStartDateInKnmAct,
          rescheduling,
          startDate,
          stopDate,
          suspensionEventsForActEvent,
          isPm,
        });
  });
};
